// extracted by mini-css-extract-plugin
module.exports = {"item":"_3ea6fa5da8--item--vlykp","label":"_3ea6fa5da8--label--Wpn9H","description":"_3ea6fa5da8--description--M4NkM","selected-indicator":"_3ea6fa5da8--selected-indicator--apvqV"};